import { PhysicalClientDocumentAccess, PhysicalClientHistoryEntry } from "@/lib/api";
import { formatDateTime } from "@/lib/formatters";
import { filterBySearch } from "./localTableSearch";
import { describeHistoryChange, HISTORY_ACTION_LABELS } from "./physicalClientLabels";

/** Colunas do histórico como a tabela mostra: data, ação, detalhe, motivo e quem. */
export const historySearchText = (entry: PhysicalClientHistoryEntry) => [
  formatDateTime(new Date(entry.performedAt)),
  HISTORY_ACTION_LABELS[entry.action] ?? entry.action,
  describeHistoryChange(entry),
  entry.comment ?? "",
  entry.performedBy,
];

/** Colunas dos acessos ao CPF como a tabela mostra: quem, quando e motivo (o registro nunca traz o CPF). */
export const accessLogSearchText = (access: PhysicalClientDocumentAccess) => [
  access.accessedBy,
  formatDateTime(new Date(access.accessedAt)),
  access.reason ?? "",
];

/** Filtra o histórico pelo texto digitado (ver filterBySearch). */
export const filterHistory = (entries: PhysicalClientHistoryEntry[], search: string) =>
  filterBySearch(entries, search, historySearchText);

/** Filtra os acessos ao CPF pelo texto digitado (ver filterBySearch). */
export const filterAccessLog = (accesses: PhysicalClientDocumentAccess[], search: string) =>
  filterBySearch(accesses, search, accessLogSearchText);
